<script>
import {getAction} from "@/utils/http/service";
import {common_controller} from "@/api/commonService";

export default {
    name: "DictRadio",
    props: {
        value: {
            type: [String, Number, Boolean],
            default: null,
        },
        fieldNames: {
            type: Object,
            default() {
                return {
                    label: "dictLabel",
                    value: "dictValue"
                }
            }
        },
        dictName: {
            type: String,
            default: ""
        },
        exclude:{
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            internalValue: this.value,
            options: []
        }
    },
    mounted() {
        getAction({
            url: common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: this.dictName
            }
        }).then(res => {
            this.options = res.filter(t=>!this.exclude.includes(t.dictValue));
        })
    },
    watch: {
        value(newVal) {
            this.internalValue = newVal;
        },
    },
    methods: {
        handleChange(e) {
            const newValue = e.target.value;
            this.internalValue = newValue;
            this.$emit('input', newValue); // 支持 v-model
            this.$emit('change', newValue); // 支持 change 事件
        },
    },
}
</script>

<template>
    <a-radio-group :value="internalValue"
                   v-bind="$attrs"
                   @change="handleChange">
        <a-radio v-for="item in options" :key="item.dictCode" :value="item.dictValue">
            {{ item.dictLabel }}
        </a-radio>
    </a-radio-group>
</template>

<style scoped lang="less">

</style>
